// Module-level route history — tracks the previous pathname across React Router navigations.
// Updated by RouteTracker in App.js; read by components that need to know where the user came from.
export const routeHistory = { prev: null, current: null }
